import React from "react";
import { Link } from "react-router-dom";

/**
 * Wordmark — refined per Phase 3 brief.
 * "QUANTUM" (Cormorant 500, ~22px) · 2×2px gold square · "US CAPITAL PARTNERS" (Inter 500, 9.5px, tracked +0.22em, 70% opacity).
 *
 * tone='light' → navy text on light surface.
 * tone='dark'  → off-white text on navy surface; gold square stays gold.
 */
export const Wordmark = ({ tone = "light", to = "/", linkClassName = "", ...rest }) => {
  const isDark = tone === "dark";
  const main = isDark ? "text-offwhite" : "text-navy";
  const sub = isDark ? "text-offwhite/70" : "text-navy/70";

  return (
    <Link
      to={to}
      data-testid="nav-wordmark"
      aria-label="Quantum US Capital Partners — Home"
      className={`group inline-flex flex-col items-start select-none leading-none ${linkClassName}`}
      {...rest}
    >
      <span className="inline-flex items-center gap-5">
        <span
          className={`font-serif font-medium leading-none ${main}`}
          style={{ fontSize: "22px", letterSpacing: "-0.005em" }}
        >
          QUANTUM
        </span>
        <span
          aria-hidden="true"
          className="inline-block bg-gold"
          style={{ width: 4, height: 4 }}
        />
      </span>
      <span
        className={`hidden sm:inline font-sans font-medium uppercase mt-1.5 ${sub}`}
        style={{ fontSize: "9.5px", letterSpacing: "0.22em", lineHeight: 1 }}
      >
        US Capital Partners
      </span>
    </Link>
  );
};

export default Wordmark;
